import { useSelector } from "react-redux";
import {

  Navigate,
  useLocation,
} from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import LandingPage from "./LandingPage";

const AuthRoutes = () => {
  const authLoading = useSelector((state: { auth }) => state.auth.loading);
  const user = useSelector((state: { auth }) => state.auth.currentUser);
  const location = useLocation();

  const isUserSignedIn = !!user && !authLoading;
  const params = new URLSearchParams(location.search);

  const settingsParam = params.get("settings");

  // Store deep-link param temporarily
  if (settingsParam) {
    localStorage.setItem("postLoginSettings", settingsParam);
    params.delete("settings");
  }
  if (authLoading) return <></>;

  return isUserSignedIn
    ? (
        <Navigate to={`/chat/${uuidv4()}`} />
      )
    : (
        <LandingPage />
      );
};

export default AuthRoutes;
